import React from 'react'
import '../styles/Logo.css'

const Logo = () => {
  return (
    <div className="logo-styles">
      <div className="z-logo-container"> z
      <div className="s-logo-container"> s</div>
      </div>
    </div>
  )
}

export default Logo
